<form [formGroup]="formGroup">
    <div class="order-upsert-form-wrapper">
        <div class="item rounded freight-payer-grid p-2">
            <div class="row">
              <div class="p-2">
                <div class="mb-2 mogo-header-2 text-start p-2 border-bottom">
                  Freight Payer
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                  <ng-select
                      id="freight-payer-search"
                      class="mb-1 required"
                      [items]="freightPayers"
                      bindLabel="name"
                      bindValue="clienteleId"
                      dropdownPosition="bottom"
                      formControlName="freightPayer">
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="text-md-start">
                          {{ item.name }}
                        </div>
                    </ng-template>
                  </ng-select>
              </div>
            </div>
        </div>

        <div class="item rounded collect-from-form-wrapper">
            <app-collect-from-form [disableEmitter]="disableEmitter" [formGroup]="formGroup"></app-collect-from-form>
        </div>

        <div class="item rounded delivery-to-from-wrapper">
            <app-delivery-to-form [disableEmitter]="disableEmitter" [formGroup]="formGroup"></app-delivery-to-form>
        </div>

        <div class="item rounded product-detail-form-wrapper">
            <app-product-detail-form
                [formGroup]="formGroup"
                [dangerousProductCodes]="dangerousProductCodes$ | async"
                [disableEmitter]="disableEmitter"
            ></app-product-detail-form>
        </div>

        <div class="item rounded order-detail-form-wrapper">
            <app-order-detail-form [formGroup]="formGroup" [disableEmitter]="disableEmitter"></app-order-detail-form>
        </div>

        <div class="item rounded pallet-information-form-wrapper">
            <app-pallet-information-form [formGroup]="formGroup" [disableEmitter]="disableEmitter"></app-pallet-information-form>
        </div>

        <div class="item rounded order-documents-wrapper">
            <app-order-documents-form [formGroup]="formGroup" [disableEmitter]="disableEmitter"></app-order-documents-form>
        </div>

        <div class="item rounded text-md-end form-footer-wrapper">

          @if(orderCreatedSuccessMode){
            <button class="btn btn-info me-2 text-light" (click)="printConsignmentNote()">Print Consignment Note</button>
            <button class="btn btn-info me-2 text-light" (click)="printLabels()">Print Labels</button>
          }@else{
            <button class="btn btn-danger me-2" (click)="clearForm()">Clear Form</button>
            <button class="btn btn-primary me-2" (click)="saveDefaults()">Save Defaults</button>
            <button class="btn btn-primary me-2" (click)="clearDefaults()">Clear Defaults</button>

        }

          @if (!orderId) {
            @if(orderCreatedSuccessMode){
              <button class="btn btn-success" (click)="clearAndCreate()">
                Clear & Create New Job
              </button>
            }@else{
              <button class="btn btn-success" (click)="submit()">
                Save
              </button>
            }
          } @else {
            <button class="btn btn-success" (click)="submit()">
              Update
            </button>
          }
        </div>
    </div>
</form>
